// extracted by mini-css-extract-plugin
module.exports = {"root":"PrevBar_root__jOwCP","black":"PrevBar_black__11qGc","button":"PrevBar_button__nFVMV","link":"PrevBar_link__3UQ6f"};